import { NSBoxSearch, NSCopy, NSDialog, NSDialogProps, NSLoading } from 'namirasoft-site-react';
import { Component } from 'react';
import { NamirasoftWorkspaceServer, WorkspaceRow } from 'namirasoft-workspace';
import { NSARouterMakerProps } from '../NSARouterMakerProps';
import { EnvService, SearchOperation } from 'namirasoft-core';
import Styles from './NSAWorkspaceListDialog.module.css';

export interface NSAWorkspaceListDialogProps extends NSARouterMakerProps, NSDialogProps
{ }

export interface NSAWorkspaceListDialogState
{
	workspaces: WorkspaceRow[] | null;
	default_id: string | null;
	current_id: string | null;
	search: string;
}

export class NSAWorkspaceListDialog extends Component<NSAWorkspaceListDialogProps, NSAWorkspaceListDialogState>
{
	constructor(props: NSAWorkspaceListDialogProps)
	{
		super(props);
		this.state = {
			workspaces: null, search: "", default_id: null, current_id: null
		};
		this.workspaceClickHandler = this.workspaceClickHandler.bind(this);
	}
	override componentDidMount(): void
	{
		let REACT_APP_BASE_URL_WORKSPACE = new EnvService("REACT_APP_BASE_URL_WORKSPACE", true).getString();
		let server = new NamirasoftWorkspaceServer(REACT_APP_BASE_URL_WORKSPACE, this.props.account.token_manager, this.props.notifier.onError);
		server.workspace.List([], null, null, []).then(res =>
		{
			this.setState({ workspaces: res.rows, default_id: res.default_id, current_id: res.current_id });
		}).catch(() => { });
	}

	workspaceClickHandler(id: string)
	{
		let REACT_APP_BASE_URL_WORKSPACE = new EnvService("REACT_APP_BASE_URL_WORKSPACE", true).getString();
		let server = new NamirasoftWorkspaceServer(REACT_APP_BASE_URL_WORKSPACE, this.props.account.token_manager, this.props.notifier.onError);
		server.workspace.SetCurrent(id)
			.then(() =>
			{
				this.props.onClose();
				this.props.notifier.onSuccess("The Current workspace was switched successfully.");
				this.props.notifier.onSuccess(`Refreshing the page ...`, 2000);
				setTimeout(() =>
				{
					document.location.reload();
				}, 2000);
			})
			.catch(() => { });
	}

	override render()
	{
		let content = null;
		let getName = (workspace: WorkspaceRow) =>
		{
			let ans = "";
			if (workspace.id === this.state.default_id && workspace.id === this.state.current_id)
				ans += "(Default and Current)";
			else if (workspace.id === this.state.default_id)
				ans += "(Default)";
			else if (workspace.id === this.state.current_id)
				ans += "(Current)";
			return ans;
		};
		let getColor = (workspace: WorkspaceRow) =>
		{
			if (workspace.id === this.state.current_id)
				return "lightgreen";
			if (workspace.id === this.state.default_id)
				return "lightblue";
			return "unset";
		};
		if (this.state.workspaces === null)
		{
			content = <NSLoading />;
		} else
		{
			let workspaces = SearchOperation.filter(this.state.workspaces, p => p.name, this.state.search);
			let def = workspaces.find(p => p.id === this.state.default_id);
			let cur = workspaces.find(p => p.id !== this.state.default_id && p.id === this.state.current_id);
			let rest = workspaces.filter(p => p.id !== this.state.default_id && p.id !== this.state.current_id);
			workspaces = [...[cur, def].filter(x => x) as WorkspaceRow[], ...rest];
			let content_workspaces = (
				<div className={Styles.nsa_workspace_list}>
					{
						workspaces.map((workspace) => (
							<div
								key={workspace.id}
								className={Styles.nsa_workspace_border}
								onClick={() => this.workspaceClickHandler(workspace.id)}
								style={{ backgroundColor: getColor(workspace) }}
							>
								<img src={"https://static.namirasoft.com/image/namirasoft/workspace/logo/base.png"} alt='No Profile' width={48} height={48} style={{ cursor: "pointer" }} />
								<div className='d-flex flex-column align-items-start'>
									<h2 className={Styles.nsa_workspace_h2} style={{ display: "flex", alignItems: "center" }}>
										{
											workspace.name
										}
										&nbsp;
										<p style={{
											margin: "0px",
											fontSize: "10px"
										}}
										>
											{
												getName(workspace)
											}
										</p>
									</h2>
									<NSCopy
										id={workspace.id}
									>
										<h6 className={Styles.nsa_workspace_h6}>{workspace.id}</h6>
									</NSCopy>
								</div>
							</div>
						))
					}
				</div >
			);
			content = (
				<>
					<NSBoxSearch
						title=''
						required={false}
						placeholder='Search your workspace'
						style={{ width: "302px" }}
						onChanged={(e) =>
						{
							this.setState({ search: e.getValue() ?? "" });
						}}
					/>
					{content_workspaces}
				</>
			);
		}
		return (
			<NSDialog {...this.props} onClose={this.props.onClose} >
				{content}
			</NSDialog>
		);
	}
}